export const ADMIN_LIST_DEFAULT_PER_PAGE = 20;
